import { render, staticRenderFns } from "./videoManage.vue?vue&type=template&id=0cb282c0&scoped=true&"
import script from "./videoManage.vue?vue&type=script&lang=js&"
export * from "./videoManage.vue?vue&type=script&lang=js&"
import style0 from "./videoManage.vue?vue&type=style&index=0&id=0cb282c0&scoped=true&lang=scss&"
import style1 from "./videoManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb282c0",
  null
  
)

export default component.exports